/**
 * Platform File System Operations
 * Thin wrapper around core/fs-operations for platform datadrive
 */

import { PlatformFSContext } from './core/context'
import * as fsOps from './core/fs-operations'
import { FSListResponse, IFile } from './core/types'

// Re-export types for backward compatibility
export type { IFile }

// Singleton platform context
const platformContext = new PlatformFSContext()

/**
 * List directory contents
 */
export async function ls(params: { path: string; domain: number }): Promise<FSListResponse> {
  return fsOps.ls(platformContext, params)
}

/**
 * Move or rename file/folder
 */
export async function mv(params: { path: string; target: string; domain: number }): Promise<void> {
  return fsOps.mv(platformContext, params)
}

/**
 * Download a single file
 */
export async function download(params: { path: string; domain: number }): Promise<void> {
  return fsOps.download(platformContext, params)
}

/**
 * Delete file or folder
 */
export async function rm(params: { path: string; domain: number }): Promise<void> {
  return fsOps.rm(platformContext, params)
}

/**
 * Create a new folder
 */
export async function mkdir(params: { path: string; domain: number }): Promise<void> {
  return fsOps.mkdir(platformContext, params)
}

/**
 * Rename file or folder
 */
export async function rename(params: {
  path: string
  name: string
  domain: number
}): Promise<void> {
  return fsOps.rename(platformContext, params)
}

/**
 * Download multiple files as ZIP
 */
export async function downloadAsZip(params: { files: IFile[]; domain: number }): Promise<void> {
  return fsOps.downloadAsZip(platformContext, params)
}

/**
 * Validate file/folder name
 */
export function validFileName(filename: string): boolean {
  return fsOps.validFileName(filename)
}
